import { Amplify } from "aws-amplify";
import { parseAmplifyConfig } from "aws-amplify/utils";
import { fetchAuthSession } from "aws-amplify/auth";
import outputs from "../../../amplify_outputs.json";

const amplifyConfig = parseAmplifyConfig(outputs);

const adminOrigin = window.location.origin;
const oauth = amplifyConfig.Auth?.Cognito.loginWith?.oauth;
if (oauth) {
  oauth.redirectSignIn = [`${adminOrigin}/`];
  oauth.redirectSignOut = [`${adminOrigin}/login`];
}

// AppSync auth rules on Transaction (and other models) reference
// `identityClaim("custom:businessId")` at the field level. Cognito only emits
// `custom:*` attributes on the ID token, not the access token, so the data
// client must send the ID token for those rules to resolve. Without this, the
// CPOS-Admin group rule grants model access but per-field auth silently
// filters every row, producing empty lists in admin views.
async function authHeaders(): Promise<Record<string, string>> {
  try {
    const session = await fetchAuthSession();
    const idToken = session?.tokens?.idToken?.toString();
    return idToken ? { Authorization: idToken } : {};
  } catch {
    return {};
  }
}

Amplify.configure(amplifyConfig, {
  API: {
    GraphQL: { headers: authHeaders },
    REST: { headers: authHeaders, retryStrategy: { strategy: "no-retry" } },
  },
});
